module.exports = __webpack_public_path__ + "img/202411_06.7bd58617.jpg";